import { motion } from "framer-motion";
import { fadeUp } from "../../lib/motion";

export function FeatureCard({ icon: Icon, title, desc, compact = false }) {
  return (
    <motion.article
      variants={fadeUp}
      className={`card-lift group rounded-2xl border border-border bg-card ${compact ? "p-5" : "p-7"} hover:border-electric/40 hover:shadow-card-hover`}
      data-testid={`feature-card-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
    >
      <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-border bg-surface text-brand transition-colors duration-300 group-hover:border-electric/40 group-hover:text-electric">
        <Icon className="h-5 w-5" strokeWidth={1.8} />
      </div>
      <h3 className={`mt-5 font-semibold ${compact ? "text-[15px]" : "text-lg"}`}>{title}</h3>
      <p className={`mt-2 leading-relaxed text-muted-foreground ${compact ? "text-[13px]" : "text-sm"}`}>{desc}</p>
    </motion.article>
  );
}

export function CardGrid({ children, className = "" }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: 0.09 } } }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
